import { lazy } from 'react';
import Splash from './splash/splash';
import FiltersDialogTv from './catalog/components/tv/filters_dialog';
import OptionsDialogTv from './settings/components/tv/options_dialog';
import SearchFilterDialog from './search/components/tv/search_filter_dialog';
import DebugDialogTv from './settings/components/tv/debug_dialog';
import BlankTv from './blank/blank_tv';
import { ParentDialogTv } from '../components/parent_dialog';
import ParentPassDialog from './settings/components/tv/parent_pass_dialog';
import { ContinueWatchDialogTv } from '../components/continue_watch_dialog';
import OptionsDialogMobile from './settings/components/mobile/options_dialog';

const LoginMobileLazy = lazy(() => import('./login/login_mobile'));
const LoginTvLazy = lazy(() => import('./login/login_tv'));

const MainTvLazy = lazy(() => import('./main/main_tv'));
const TvTvLazy = lazy(() => import('./tv/tv_tv'));
const CatalogTvLazy = lazy(() => import('./catalog/catalog_tv'));

const SearchTvLazy = lazy(() => import('./search/search_tv'));
const SearchMoviesResultLazy = lazy(
  () => import('./search_result/tv/search_movies_result'),
);
const SearchChannelsResultLazy = lazy(
  () => import('./search_result/tv/search_channels_result'),
);
const SearchEpgResultLazy = lazy(
  () => import('./search_result/tv/search_epg_result'),
);

const BookmarkTvLazy = lazy(() => import('./bookmark/bookmark_tv'));
const HistoryTvLazy = lazy(() => import('./history/history_tv'));
const FavoritesTvLazy = lazy(() => import('./favorites/favorites_tv'));

const SettingsTvLazy = lazy(() => import('./settings/settings_tv'));

const CollectionsTvLazy = lazy(() => import('./collections/collections_tv'));
const DetailsTvLazy = lazy(() => import('./details/details_tv'));
const PlayerTvLazy = lazy(() => import('./player/player_tv'));

const PlayerMobileLazy = lazy(() => import('./player/player_mobile'));

const TabsMobileLazy = lazy(() => import('./tabs/tabs_mobile'));

export {
  //start screens
  Splash,
  LoginTvLazy as LoginTv,
  LoginMobileLazy as LoginMobile,

  //root tv screens
  MainTvLazy as MainTv,
  TvTvLazy as Tv,
  CatalogTvLazy as CatalogTv,
  SearchTvLazy as SearchTv,
  SettingsTvLazy as SettingsTv,
  BlankTv,

  //bookmark tv screens
  BookmarkTvLazy as BookmarkTv,
  HistoryTvLazy as HistoryTv,
  FavoritesTvLazy as FavoritesTv,

  //search result screens
  SearchMoviesResultLazy as SearchMoviesResult,
  SearchChannelsResultLazy as SearchChannelsResult,
  SearchEpgResultLazy as SearchEpgResult,

  //secondary tv screens
  CollectionsTvLazy as CollectionsTv,
  DetailsTvLazy as DetailsTv,
  PlayerTvLazy as PlayerTv,

  //tv dialogs
  FiltersDialogTv,
  OptionsDialogTv,
  SearchFilterDialog,
  DebugDialogTv,
  ParentDialogTv,
  ParentPassDialog,
  ContinueWatchDialogTv,

  //root mobile
  TabsMobileLazy as MainMobile,
  PlayerMobileLazy as PlayerMobile,

  //mobile dialogs
  OptionsDialogMobile,
};
